import api from '../../../../axios'
import { viewerConstants } from '../../../_reducers/viewer'

export const getFeatureDescription = (report) => (dispatch) => {
	api.get(`get_feature_description?feature_key=${report}`).then(({ data }) =>
		dispatch({
			type: viewerConstants.HOW_IT_WORKS,
			payload: data,
		})
	)
}
